import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as navigationActions from "@flow/store/navigation/actions";
import { withRouteData } from "react-static";
import SEOTags from "@flow/components/seo/SEOTags";
import {
  ContentContainer,
  SingleColumnLayout,
  SingleColumnLayoutContentWrapper,
  SingleColumnLayoutHeader,
} from "@flow/components/ui";
import { ProgramNavigation } from "@flow/components/navigation/ProgramNavigation";
import { IPage } from "types/IPage";
import { PROGRAM_PAGE_NAVIGATION_ENABLED } from "@flow/utils/constants";
import { renderContent } from "@flow/scenes/default/ui";
import { Schedule } from "@flow/scenes/schedule/ui/Schedule";
import { MySchedule } from "@flow/scenes/schedule/ui/MySchedule";
import * as myFlowActions from "@flow/store/myflow/actions";
import * as userActions from "@flow/store/user/actions";
import * as favouriteActions from "@flow/store/favourites/actions";
import { MyFlowState } from "@flow/store/myflow/reducer";
import {
  AddToMyFlow,
  HashMapItems,
  RemoveFromMyFlow,
  SetFBAuth,
  SetInitialMyFlowData,
} from "types/MyFlow";
import Authentication from "@flow/components/auth/Authentication";

interface Props {
  appLanguage: IAppLanguage;
  programPageNavigation: ProgramPageNavigation;

  userState: UserState;
  userData: UserData;
  user: User;
  setFavourites: (req: PutFavouriteRequest) => void;
  getFavourites: (req: GetFavouriteRequest) => void;
  setUser: (user: UserData) => void;
  setMyFlow: (eventIds: string[]) => void;
  logOut: () => void;

  page: IPage;
  setLanguage: any;
  myFlow: MyFlowState;
  setInitialData: (params: SetInitialMyFlowData) => any;
  addToMyFlow: (params: AddToMyFlow) => any;
  removeFromMyFlow: (params: RemoveFromMyFlow) => any;
  initialIdHashMap: HashMapItems;
  requestingFBAuth: () => any;
  setFBAuth: (params: SetFBAuth) => any;
  unsetFBAuth: () => any;
}

type State = {
  isLoggedIn: boolean;
  requestingCurrentLoginStatus: boolean;
};

class SchedulePage extends Component<Props, State> {
  state = {
    isLoggedIn: false,
    requestingCurrentLoginStatus: true,
  };

  constructor(props: Props) {
    super(props);
  }

  componentWillMount() {
    const { appLanguage, page, initialIdHashMap, setLanguage, setInitialData } =
      this.props;

    const lang_versions = page && page.lang_versions;

    setLanguage({ appLanguage, lang_versions });
    setInitialData({ hashMapItems: initialIdHashMap });
  }

  componentWillReceiveProps({ appLanguage, page, initialIdHashMap }: Props) {
    const { setLanguage, setInitialData } = this.props;

    if (appLanguage.code !== this.props.appLanguage.code) {
      const lang_versions = page && page.lang_versions;

      setLanguage({ appLanguage, lang_versions });
      setInitialData({ hashMapItems: initialIdHashMap });
    }
  }

  render() {
    const { page, programPageNavigation } = this.props;

    const { content_group } = page;

    return (
      <Fragment>
        <SEOTags page={page} />
        <SingleColumnLayout>
          <SingleColumnLayoutHeader>
            {PROGRAM_PAGE_NAVIGATION_ENABLED ? (
              <ProgramNavigation
                programPageNavigation={programPageNavigation}
              />
            ) : (
              <h2>{page.title}</h2>
            )}
          </SingleColumnLayoutHeader>
          <SingleColumnLayoutContentWrapper style={{ marginBlock: "5em" }}>
            {renderContent(content_group)}
          </SingleColumnLayoutContentWrapper>
          <SingleColumnLayoutContentWrapper style={{ marginBlock: "5em" }}>
            <ContentContainer>
              <Authentication />
            </ContentContainer>
          </SingleColumnLayoutContentWrapper>
          {[this._renderArtistsSchedule(), this._renderUserSchedule()]}
        </SingleColumnLayout>
      </Fragment>
    );
  }

  private _renderUserSchedule = () => {
    const { appLanguage } = this.props;
    return <MySchedule appLanguage={appLanguage} />;
  };

  private _renderArtistsSchedule = () => {
    const { appLanguage } = this.props;
    return <Schedule appLanguage={appLanguage} />;
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getFavourites: () => {
      dispatch(favouriteActions.fetchFavourites());
    },
    setLanguage: ({ appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(navigationActions.setLanguage(appLanguage, lang_versions));
    },
    setInitialData: (params: SetInitialMyFlowData) =>
      dispatch(myFlowActions.setInitialData(params)),
    setFavourites: (params: PutFavouriteRequest) =>
      dispatch(userActions.setFavourites(params)),
    setMyFlow: (eventIds: string[]) =>
      dispatch(myFlowActions.setMyFlow(eventIds)),
    setUser: (params: UserData) => dispatch(userActions.setUser(params)),
    logOut: () => dispatch(userActions.logOut()),
  };
};

export default withRouteData(
  connect(
    (state: any) => ({
      myFlow: state.myFlowReducer,
      userState: state.user,
      userData: state.user.userData,
      user: state.auth.user,
    }),
    mapDispatchToProps
  )(SchedulePage)
);



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/schedule/SchedulePage.tsx